import React, {Component, useEffect, useMemo,} from 'react';
import {BrowserRouter as Router, Route} from "react-router-dom";

import {Switch} from "react-router";
// ie stuff
import "babel-polyfill";
import {polyfill} from 'es6-promise';
import cssVars from 'css-vars-ponyfill';
import {placeholderClub} from "./core/custom";
import Nav from "./nav";
import CheckLogin from "./user/check_login";
import {UserContext} from "./user/UserContext";

import Login from "./user/login";


import ErrorBoundary from "./core/error_boundary";
import ChangePW from "./user/changepw";


import NewsRedir from "./course/news_redir";
import ResetAdminUserChange from "./user/reset_admin_user_change";
import {RouteMax} from "./core/components/asyncComponentWrapper";

polyfill();
Number.prototype.pad = function (size) {
    var s = String(this);
    while (s.length < (size || 2)) {
        s = "0" + s;
    }
    return s;
}
// end ie stuff
function ScrollToTop({location}) {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);
    return null;
}

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            navOpen: localStorage.getItem("mainContainer") === null ? (window.innerWidth > 1025) : localStorage.getItem("mainContainer") !== "false",
            navToggle: () => {
                localStorage.setItem("mainContainer", !this.state.navOpen);
                this.setState({navOpen: !this.state.navOpen})
            },
            mounted: false,
            club: JSON.parse(localStorage.getItem("verein_cache")) || placeholderClub
        };
        this.setCssVars(this.state.club)
    }

    addUserFromStatus = resp => {
        !!resp.club && this.setCssVars(resp.club);
        this.setState(resp);
    };

    setCssVars = club => {
        window.ReactNativeWebView && window.ReactNativeWebView.postMessage(JSON.stringify(window.safeAreaInsets))
        const variables = {
            "mainColor": club.color,
            "fontColor": club.fontColor || "#444",
            "fontColorInverse": club.fontColorInverse || "#fff",
            ...["Top", "Right", "Bottom", "Left"].reduce((obj, curr) => ({...obj, ["safeAreaInset" + curr]: ((window.safeAreaInsets || {})[curr.toLowerCase()] ?? 0) + "px"}), {}),
        };
        cssVars({
            rootElement: document,
            variables,
        });
    }
    cacheInsetVariable = () => {
        if (!window.safeAreaInsets) {
            window.safeAreaInsets = JSON.parse(localStorage.getItem("safeAreaInsets") || "{}")
        } else {
            localStorage.setItem("safeAreaInsets", JSON.stringify(window.safeAreaInsets))
        }
    }

    componentWillMount() {
        const club = JSON.parse(localStorage.getItem("verein_cache")) || placeholderClub;
        this.cacheInsetVariable()
        this.setCssVars(club)
        if (window.ReactNativeWebView) {
            window.setInterval(() => {
                if (window.safeAreaInsets2 && JSON.stringify(window.safeAreaInsets2) !== localStorage.getItem("safeAreaInsets")) {
                    this.cacheInsetVariable()
                    const club = JSON.parse(localStorage.getItem("verein_cache")) || placeholderClub;
                    this.setCssVars(club)
                }
            }, 500)
        }
    }

    componentDidUpdate = (prevProps, prevState, snapshot) => {

    }

    render() {
        return (
            <Router>

                <UserContext.Provider value={{...this.state, setState: this.setState}}>
                    <div className={"version-tag"} style={{
                        position: "fixed",
                        bottom: (window.safeAreaInsets?.bottom || 0) + "px",
                        right: 0,
                        fontSize: "10px",
                        zIndex: 1000,
                        backgroundColor: "white",
                        padding: "5px",

                    }}>
                        version {window.vatomatorVersion}
                    </div>
                    <div className={"App " + (window.location.hostname === "localhost" ? "blue" : "tvg")}>
                        <ErrorBoundary key={"ljljfs"}>
                            <Route path="/" render={(props) => <CheckLogin {...props} addUserFromStatus={this.addUserFromStatus}/>}/>
                            {
                                /*!!this.state.user && this.state.user.status === "logged_in" &&*/
                                <Route path="/" component={Nav}/>
                            }
                            <Route path="/" component={ScrollToTop}/>
                            <Route path="/" render={(props) => <ResetAdminUserChange {...props}/>}/>
                        </ErrorBoundary>
                        <MainContainer>
                            <div id={"mainOverlayForNav"}/>
                            <ErrorBoundary key={"ljljfs"}>
                                <Switch>
                                    <Route exact path="/benutzer/changepw/:token" component={ChangePW}/>

                                    <RouteMax exact path="/faq/:topic" component={() => import("./docs/faq")}/>
                                    <RouteMax exact path="/faq" component={() => import("./docs/faq")}/>

                                    <RouteMax exact path="/benutzer/tote" component={() => import("./user/user_dead_list")}/>
                                    <RouteMax exact path="/benutzer/registrierungen" component={() => import("./user/user_lastregistrations")}/>
                                    <RouteMax exact path="/benutzer/saldo" component={() => import("./user/user_offen")}/>
                                    <RouteMax exact path="/benutzer/sview/:userID" component={() => import("./user/user_offen")}/>
                                    <RouteMax exact path="/benutzer/sprofil/:userID" component={() => import("./user/user_offen")}/>
                                    <RouteMax exact path="/benutzer/jubilare" component={() => import("./user/user_birthdays")}/>
                                    <RouteMax exact path="/benutzer/aktiv" component={() => import("./user/user_general_list_instances")} importName={"ActiveList"}/>
                                    <RouteMax exact path="/benutzer/trainer" component={() => import("./user/user_general_list_instances")} importName={"TrainersList"}/>
                                    <RouteMax exact path="/benutzer/aktivOderVerwalter" component={() => import("./user/user_general_list_instances")} importName={"ActiveUserActiveManagerList"}/>
                                    <RouteMax exact path="/benutzer/aview/:userID" component={() => import("./user/user_general_list_instances")} importName={"ActiveList"}/>
                                    <RouteMax exact path="/benutzer/aprofil/:userID" component={() => import("./user/user_general_list_instances")} importName={"ActiveList"}/>
                                    <RouteMax exact path="/benutzer/admins" component={() => import("./user/user_general_list_instances")} importName={"ActiveAdminsList"}/>
                                    <RouteMax exact path="/benutzer/adview/:userID" component={() => import("./user/user_general_list_instances")} importName={"ActiveAdminsList"}/>
                                    <RouteMax exact path="/benutzer/liste/:userID" component={() => import("./user/user_general_list_instances")} importName={"UsersList"}/>
                                    <RouteMax exact path="/benutzer/liste" component={() => import("./user/user_general_list_instances")} importName={"UsersList"}/>
                                    <RouteMax exact path="/benutzer/verwalterliste" component={() => import("./user/user_general_list_instances")} importName={"UsersManagerList"}/>
                                    <RouteMax exact path="/benutzer/schnell" component={() => import("./user/user_general_list_instances")} importName={"UsersListFast"}/>
                                    <RouteMax exact path="/benutzer/nachRolle" component={() => import("./user/user_general_list_instances")} importName={"ChildsByRole"}/>
                                    <RouteMax exact path="/benutzer/registrieren" component={() => import("./user/user_registerAsAdmin")}/>
                                    <RouteMax exact path="/benutzer/view/:userID" component={() => import("./user/user_view")}/>
                                    <RouteMax exact path="/benutzer/profil/:userID" component={() => import("./user/user_view")}/>
                                    <RouteMax exact path="/benutzer/history" component={() => import("./user/user_history_all")}/>
                                    <RouteMax exact path="/session" component={() => import("./user/user_session")}/>
                                    <RouteMax exact path="/abrechnung" component={() => import("./abrechnung/main")}/>
                                    <RouteMax path="/abrechnung/ratenzahlung" component={() => import("./abrechnung/splitpayment")}/>
                                    <RouteMax path="/abrechnung/authentication" component={() => import("./abrechnung/stripe_auth_wrapper")}/>
                                    <RouteMax exact path="/abrechnung/:userID" component={() => import("./abrechnung/main")}/>
                                    <RouteMax path="/prae/:praeForm_ID" component={() => import("./course/prae_edit")}/>
                                    <RouteMax path="/prae" component={() => import("./course/prae_home")}/>

                                    <RouteMax exact path="/bezahlmethode/add/:preferredMethod" component={() => import("./abrechnung/zahlungsmethode_add")}/>
                                    <RouteMax exact path="/bezahlmethode/add/:preferredMethod/:child_ID" component={() => import("./abrechnung/zahlungsmethode_add")}/>
                                    <RouteMax exact path="/bezahlmethode/add" component={() => import("./abrechnung/zahlungsmethode_add")}/>
                                    <RouteMax exact path="/bezahlmethode/add_for/:child_ID" component={() => import("./abrechnung/zahlungsmethode_add")}/>
                                    <RouteMax exact path="/zahlung/:payment_token" component={() => import("./abrechnung/zahlung_public")}/>

                                    <RouteMax path="/buchhaltung/buchungen/:kontonr" component={() => import("./buchhaltung/ledger_view")}/>
                                    <RouteMax path="/buchhaltung/buchungen" component={() => import("./buchhaltung/ledger_view")}/>

                                    <RouteMax path="/buchhaltung/bankimport" component={() => import("./buchhaltung/bank_import")}/>
                                    <RouteMax path="/buchhaltung/bankexport" component={() => import("./buchhaltung/bank_export")}/>
                                    <RouteMax path="/buchhaltung/geschaeftsjahr" component={() => import("./buchhaltung/business_year")}/>
                                    <RouteMax path="/buchhaltung/konten" component={() => import("./buchhaltung/accounts")}/>
                                    <RouteMax path="/buchhaltung/berichte" component={() => import("./buchhaltung/accounting_reports")}/>
                                    <RouteMax path="/buchhaltung/zuordnung" component={() => import("./buchhaltung/attribution")}/>
                                    <RouteMax path="/buchhaltung/mitgliederzuordnung" component={() => import("./buchhaltung/user_attribution")}/>
                                    <RouteMax path="/buchhaltung/dashboard" component={() => import("./buchhaltung/dashboard")}/>
                                    <RouteMax path="/buchhaltung/barzahlung" component={() => import("./buchhaltung/cashpayment_add")}/>

                                    <RouteMax path="/rechnungen" component={() => import("./buchhaltung/invoices")}/>
                                    <RouteMax path="/rechnung/vorlagen" component={() => import("./buchhaltung/invoice_templates_list")}/>

                                    <RouteMax path="/änderungen" component={() => import("./core/list_commits")}/>
                                    <RouteMax path="/export" component={() => import("./core/exportDump")}/>

                                    <RouteMax exact path="/mitgliedschaft" component={() => import("./user/user_membership")}/>
                                    <RouteMax exact path="/kontakt" component={() => import("./user/user_message")}/>
                                    <RouteMax exact path="/mitgliedsbeiträge" component={() => import("./club/membershipfees")}/>
                                    <RouteMax exact path="/rollen" component={() => import("./club/roles")}/>

                                    <RouteMax exact path="/registrieren" component={() => import("./user/register")}/>
                                    <RouteMax exact path="/checkout/:tag_ID" component={() => import("./user/register")}/>
                                    <RouteMax exact path="/verwalterRegistrieren" component={() => import("./user/user_addMyVerwalter")}/>
                                    <RouteMax exact path="/aktivieren" component={() => import("./user/register")}/>
                                    <RouteMax exact path="/registrieren/:course_ID" component={() => import("./user/register")}/>

                                    <RouteMax exact path="/dash" component={() => import("./dashboard/members")}/>

                                    {/*<Route path="/benutzer/newsletter" component={BeeTemplates}/>*/}
                                    {/*<Route path="/benutzer/bee" component={MyBee}/>*/}
                                    {/*<Route path="/benutzer/stripo" component={Stripo}/>*/}
                                    {/*<Route path="/newsletter/unlayer" component={Unlayer}/>*/}
                                    <RouteMax path="/newsletter/vorlagen" component={() => import("./newsletter/templates_list")}/>
                                    <RouteMax path="/newsletter/sendungen" component={() => import("./newsletter/newsletters")}/>
                                    <RouteMax path="/newsletter/statistik/:newsletter_ID" component={() => import("./newsletter/newsletter_stats")}/>
                                    <RouteMax path="/newsletter/:template_ID" component={() => import("./newsletter/unlayer")}/>
                                    <RouteMax path="/newsletter/neu" component={() => import("./newsletter/unlayer")}/>
                                    <RouteMax path="/cloudstorage/anleitung" component={() => import("./user/nextcloud_guide")}/>
                                    <RouteMax path="/cloudstorage" component={() => import("./user/nextcloud")}/>
                                    <RouteMax path="/editor/:template_ID/:accessToken" component={() => import("./pages/file_editor")}/>

                                    <RouteMax exact path="/" component={() => import("./dashboard/defaultPage")}/>
                                    <RouteMax exact path="/kurs/meine" component={() => import("./course/courses")}/>
                                    <RouteMax exact path="/kurs/meine_online" component={() => import("./course/courses")}/>
                                    <RouteMax exact path="/kurs/trainer" component={() => import("./course/courses")}/>
                                    <RouteMax exact path="/kurs/buchung/:date" component={() => import("./course/courses_available")}/>
                                    <RouteMax exact path="/kurs/buchung" component={() => import("./course/booking_router")}/>
                                    <RouteMax exact path="/kurs/buche/:courseID" component={() => import("./course/booking_router")}/>
                                    <RouteMax exact path="/kurs/buchungen" component={() => import("./user/user_general_list_instances")} importName={"LatestBookings"}/>
                                    <RouteMax exact path="/kurs/buchungen/kurs/:courseID" component={() => import("./course/courses_lastBookings")}/>
                                    <RouteMax exact path="/kurs/buchungen/user/:userID" component={() => import("./course/courses_lastBookings")}/>
                                    <RouteMax exact path="/kurs/tags" component={() => import("./course/course_tags")}/>
                                    <RouteMax exact path="/kurstag/benutzer" component={() => import("./user/course_tag_users")}/>
                                    <RouteMax path="/kurs/:courseID/anwesenheit/:eventID" component={() => import("./course/attendance")}/>
                                    <RouteMax path="/kurs/:courseID/personenanwesenheit/:childID" component={() => import("./course/attendance")}/>
                                    <RouteMax exact path="/kurse/umsatz" component={() => import("./course/turnover")}/>
                                    <RouteMax exact path="/kurse/nachrichten" component={() => import("./course/course_news_multi")}/>
                                    <RouteMax exact path="/zahlungsmodelle" component={() => import("./course/paymentPlan/course_payment_model_list")} importName={"CoursePaymentModelList"}/>
                                    <RouteMax path="/kurse/:courseID" component={() => import("./course/course_view")}/>
                                    <Route path="/kurs/:news_ID" component={NewsRedir}/>


                                    <RouteMax exact path="/kalender/atHome" component={() => import("./course/conference_calendar")}/>
                                    <RouteMax exact path="/kalender/export" component={() => import("./calendar/export")}/>
                                    <RouteMax exact path="/kalender/monat" component={() => import("./calendar/calendar")}/>
                                    <RouteMax exact path="/kalender/raum" component={() => import("./calendar/rooms")}/>

                                    <RouteMax exact path="/neuigkeiten" component={() => import("./dashboard/facebook")}/>

                                    <RouteMax exact path="/kontakte" component={() => import("./contacts/contacts_list")}/>
                                    <RouteMax exact path="/kontakte/:contactID" component={() => import("./contacts/contacts_list")}/>

                                    <RouteMax exact path="/verein" component={() => import("./club/basic_data")}/>
                                    <RouteMax exact path="/migrieren/person" component={() => import("./club/migrate_person")}/>
                                    <RouteMax exact path="/migrieren/kontenrahmen" component={() => import("./club/migrate_kontenrahmen")}/>
                                    <RouteMax exact path="/verein/konfiguration" component={() => import("./club/configure")}/>
                                    <RouteMax exact path="/verein/vorlagen" component={() => import("./club/templates")}/>
                                    <RouteMax exact path="/verein/vorstand" component={() => import("./club/board")}/>
                                    <RouteMax exact path="/standesmeldung" component={() => import("./club/standesmeldung")}/>
                                    <RouteMax exact path="/berechtigungen" component={() => import("./club/permissions")}/>
                                    <RouteMax exact path="/tags" component={() => import("./core/TagsEditor")}/>

                                    <RouteMax exact path="/meineMitgliedskarte" component={() => import("./user/ams_usercode")}/>
                                    <RouteMax exact path="/ti/:token" component={() => import("./user/ams_ticket")}/>
                                    <RouteMax exact path="/ams/kiosk" component={() => import("./user/ams_kiosk")}/>
                                    <RouteMax exact path="/unsubscribe/:token" component={() => import("./user/newsletter_unsubscribe")}/>

                                    <RouteMax exact path="/gutscheine" component={() => import("./voucher/vouchers_list")}/>
                                    <RouteMax exact path="/gutscheine/verkaufen" component={() => import("./voucher/vouchers_sell")}/>
                                    <RouteMax exact path="/gutscheine/kaufen" component={() => import("./voucher/voucher_buy")}/>

                                    <RouteMax exact path="/athome/:subslot" component={() => import("./pages/turnverein_at_home")}/>
                                    {/*<RouteMax exact path="/medien" component={() => import("./pages/medien")}/>*/}
                                    <RouteMax exact path="/medien" component={() => import("./pages/medien")}/>
                                    <RouteMax exact path="/medien/:subslot" component={() => import("./pages/medien")}/>
                                    <RouteMax exact path="/formulare/:subslot" component={() => import("./pages/forms")}/>
                                    <RouteMax exact path="/formular/uebersicht" component={() => import("./pages/form_overview")}/>

                                    <RouteMax exact path={"/embed/konfigurator"} component={() => import("./course/embed_config")}/>
                                    <RouteMax exact path={"/embed/:verein/:tag"} component={() => import("./course/embed")}/>
                                    <RouteMax exact path={"/getCustomClub"} component={() => import("./core/custom_exporter")}/>
                                    <RouteMax exact path={"/testraum"} component={() => import("./course/conference_test")}/>
                                    <RouteMax exact path={"/recordee"} component={() => import("./recordee/recordee")}/>
                                    <RouteMax exact path={"/recordee/:roomName"} component={() => import("./recordee/recordee")}/>


                                    <RouteMax exact path={"/profil/:child_ID"} component={() => import("./user/profile")}/>
                                    <RouteMax exact path={"/trainer"} component={() => import("./user/profileTrainer")} props={{mode: "trainer"}}/>
                                    <RouteMax exact path={"/vorstand"} component={() => import("./user/profileTrainer")} props={{mode: "board"}}/>
                                    <RouteMax exact path={"/trainer/anwesenheitprokurs"} component={() => import("./user/trainer_attendances")}/>
                                    <RouteMax exact path={"/sendungseinstellungen"} component={() => import("./user/notificationSettings")}/>

                                    <RouteMax exact path="/raum/buchungen" component={() => import("./room/room_reservation")}/>
                                    <RouteMax exact path="/raum/preise" component={() => import("./room/room_prices")}/>

                                    <RouteMax exact path="/meineVereine" component={() => import("./user/vereinid")}/>

                                    <RouteMax exact path="/rabatte" component={() => import("./course/discount")}/>
                                    <RouteMax exact path="/zahlungen" component={() => import("./abrechnung/zahlungen_alle")}/>
                                    <RouteMax exact path="/inventar" component={() => import("./club/inventory_list")}/>

                                    <Route path={"/"} component={Notfound}/>
                                </Switch>
                            </ErrorBoundary>
                        </MainContainer>
                        <article style={{zIndex: 100, width: "100%"}}>
                            <RouteMax path="/benutzer/select" component={() => import("./user/user_general_list_instances")} importName={"UsersList"}/>
                            <Route path="/benutzer/login" component={Login}/>
                            <Route path="/benutzer/logout" render={(props) => <Login {...props} addUserFromStatus={this.addUserFromStatus}/>}/>

                        </article>

                    </div>
                </UserContext.Provider>
            </Router>
        );
    }
}


class MainContainer extends React.Component {
    state = {
        mounted: false,
    };
    componentDidMount = () => {
        window.setTimeout(() => {
            this.setState({mounted: true})
        }, 2000);
    };
    static contextType = UserContext;

    render() {
        const userContext = this.context;
        return <article style={{zIndex: 10}} id={"mainContainer"}
                        className={
                            (userContext.navOpen && !!userContext.user && userContext.user.status === "logged_in" ?
                                    "open" :
                                    (!!userContext.user && userContext.user.status === "logged_in" ? "closed" : "navNotExistent")
                            ) +
                            (this.state.mounted ? " postLoad" : "")}
                        onClick={() => userContext.navOpen && !!userContext.user && userContext.user.status === "logged_in" && window.innerWidth < 500 && userContext.navToggle()}
        >
            {this.props.children}
        </article>
    }
}

function Notfound(props) {
    if (props.location.pathname.indexOf("/benutzer") > -1) {
        return null
    }
    return <div><h1>Fehler</h1>Diese Funktion wird in Kürze hinzugefügt!</div>
}

export default App;
